export default __webpack_public_path__ + "static/media/invoice.6858bca8.png";